import { MuiTheme, createStyles, makeStyles, color } from '@kis-technologies/kis-ui';

export const useStyles = (props?: { showDrawer: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      kioskDetailsOuterBox: {
        flex: 'none',
        background: 'transparent',
        padding: '0px 40px',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 20px 20px'
        }
      },
      kioskDetailsTableContainer: {
        height: '700px',
        [theme.breakpoints.down('sm')]: {
          height: '770px'
        }
      },
      kioskDetailsHeaders: {
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600,
        cursor: 'pointer'
      },
      kioskDetailsKioskName: {
        paddingLeft: '24px',
        color: 'inherit'
      },
      kioskDetailsCell: {
        color: 'inherit'
      },
      Active: {
        color: '#2A2A2A'
      },
      Inactive: {
        color: '#C40B0F'
      },
      kioskDetailsNameInactive: {
        color: '#C40B0F',
        paddingLeft: '24px !important'
      },
      saveButtonBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.only('xs')]: {
          margin: '32px 0px'
        }
      },
      ReloadDataButton: {
        '& > *': {
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex'
        },
        '& > * > * ': {
          height: '50px',
          width: '60%'
        },
        '& > * > * > input': {
          minWidth: 'auto'
        }
      },
      kioskRestockBox: {
        flex: '1',
        background: 'transparent',
        padding: '32px 24px',
        '& > * > * > * > *': {
          [theme.breakpoints.down('xs')]: {
            whiteSpace: 'normal'
          }
        },
        [theme.breakpoints.only('xs')]: {
          padding: '8px'
        },
        [theme.breakpoints.up('md')]: {
          padding: '32px 48px'
        }
      },
      restockPrinterLabel: {
        maxWidth: '150px',
        textAlign: 'center',
        fontSize: '16px',
        margin: '0px',
        fontWeight: 400,
        [theme.breakpoints.only('xs')]: {
          whiteSpace: 'normal'
        }
      },
      saveButton: {
        width: '200px',
        [theme.breakpoints.only('xs')]: {
          width: '150px'
        }
      },
      kiosksHeaderBlock: {
        justifyContent: 'space-between',
        background: 'transparent',
        padding: '24px 40px',
        display: 'flex',
        height: '100px',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'row',
          gap: '20px'
        },
        [theme.breakpoints.down('sm')]: {
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '18px 20px 18px 20px',
          flexDirection: 'row',
          height: '100px'
        },
        [theme.breakpoints.only('xs')]: {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '18px 0px 18px 0px',
          height: '100%'
        }
      },
      kiosksHeading: {
        fontSize: '40px',
        lineHeight: '1',
        fontWeight: 600,
        letterSpacing: 'normal',
        margin: '0px',
        [theme.breakpoints.between('xs', 'sm')]: {
          fontSize: '36px'
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '32px'
        },
        [theme.breakpoints.only('md')]: {
          fontSize: '36px'
        }
      },
      kioskStatusHeading: {
        fontSize: '24px',
        lineHeight: 'inherit',
        letterSpacing: 'normal',
        margin: '0px',
        [theme.breakpoints.down('xs')]: {
          fontSize: '20px'
        }
      },
      autoRefreshContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      },
      autoRefreshHeading: {
        fontSize: '18px',
        lineHeight: 'inherit',
        letterSpacing: 'normal',
        padding: '8px',
        fontWeight: 600,
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
          fontSize: '20px'
        }
      },
      kioskRestockHeading: {
        fontSize: '32px',
        lineHeight: 'inherit',
        letterSpacing: 'normal',
        margin: '0px',
        [theme.breakpoints.down('xs')]: {
          fontSize: '20px'
        }
      },
      kioskTableBox: {
        flex: '1',
        background: 'transparent',
        padding: '0',
        '& > * > * > * > *': {
          [theme.breakpoints.down('xs')]: {
            whiteSpace: 'normal'
          }
        }
      },
      kioskStatusChangeTitle: {
        flex: 'none',
        width: '400px',
        background: 'transparent',
        margin: '0px 0px 24px 0px',
        [theme.breakpoints.only('sm')]: {
          width: '100%'
        },
        [theme.breakpoints.only('xs')]: {
          width: '300px'
        }
      },
      kioskStatusChangeDescription: {
        flex: 'none',
        width: '500px',
        background: 'transparent',
        [theme.breakpoints.only('sm')]: {
          padding: '0px 20px 0px 20px'
        },
        [theme.breakpoints.down('xs')]: {
          padding: '0px 40px 0px 20px',
          width: '385px',
          whiteSpace: 'normal'
        }
      },
      kioskStatusTitle: {
        lineHeight: '1',
        textAlign: 'center',
        fontSize: '48px',
        margin: '0px',
        [theme.breakpoints.only('xs')]: {
          fontSize: '28px'
        }
      },
      kioskStatusDescription: {
        textAlign: 'center',
        fontSize: '24px',
        margin: '0px',
        [theme.breakpoints.only('xs')]: {
          fontSize: '16px'
        }
      },
      kioskRebootHeading: {
        flex: 'none',
        width: '600px',
        background: 'transparent',
        margin: '0px 0px 24px 0px',
        [theme.breakpoints.only('sm')]: {
          width: '490px',
          padding: '0px 20px 0px 0px'
        },
        [theme.breakpoints.only('xs')]: {
          width: '300px'
        }
      },
      kioskRebootHeader: {
        textAlign: 'center',
        fontSize: '48px',
        margin: '0px 0px 24px 0px',
        [theme.breakpoints.only('sm')]: {
          fontSize: '35px'
        },
        [theme.breakpoints.only('xs')]: {
          fontSize: '25px'
        }
      },
      kioskRebootDescription: {
        width: '600px',
        flex: 'none',
        background: 'transparent',
        [theme.breakpoints.only('sm')]: {
          width: '360px',
          padding: '0px 10px 0px 10px'
        },
        [theme.breakpoints.only('xs')]: {
          width: '300px',
          padding: '0px 10px 0px 10px'
        }
      },
      kioskRebootDescriptionText: {
        textAlign: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        margin: '0px',
        [theme.breakpoints.only('xs')]: {
          fontSize: '20px',
          whiteSpace: 'normal'
        }
      },
      kioskHardwareHeaderType: {
        paddingLeft: '24px',
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600
      },
      kioskHardwareHeaders: {
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600
      },
      kioskHardwareTableRows: {
        height: '70px'
      },
      kioskHardwareType: {
        paddingLeft: '24px'
      },
      KioskActionsButtons: {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        '& > img': {
          cursor: 'pointer'
        }
      },
      kioskStatusRow: {
        display: 'flex',
        alignItems: 'center'
      },
      activeStatusButton: {
        color: color.BLACK,
        background: 'white',
        border: 'white',
        height: '35px',
        width: '110px',
        whiteSpace: 'nowrap',
        '&:hover': {
          background: 'white',
          border: 'white'
        },
        '& > * > * > *': {
          fill: `${color.GREEN} !important`
        }
      },
      inactiveStatusButton: {
        color: color.RED,
        background: 'white',
        border: 'white',
        height: '35px',
        width: '110px',
        whiteSpace: 'nowrap',
        '&:hover': {
          background: 'white',
          border: 'white'
        },
        '& > * > * > *': {
          fill: `${color.RED} !important`
        }
      },
      offlineStatusBox: {
        width: '110px',
        textAlign: 'center',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center'
      },
      kioskDetailsOverlay: {
        width: '616px',
        background: 'white',
        color: '#2A2A2A',
        padding: '32px 0px 32px 0px',
        [theme.breakpoints.down('sm')]: {
          width: 'auto'
        },
        [theme.breakpoints.only('xs')]: {
          width: '365px',
          padding: '10px 0px 32px 0px'
        }
      },
      kioskRestockDetailsOverlay: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column'
      },
      kioskOverlayHeaderBlock: {
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        padding: '24px 24px 24px 24px',
        gap: '10px',
        [theme.breakpoints.only('xs')]: {
          alignItems: 'flex-start',
          flexDirection: 'column-reverse',
          padding: '8px'
        }
      },
      kioskOverlayHeading: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          paddingTop: '10px',
          paddingLeft: '20px'
        }
      },
      footer: {
        width: '100%',
        overflow: 'hidden',
        padding: '0px 40px'
      },
      total: {
        float: 'right',
        fontSize: '20px',
        padding: '10px',
        margin: 0,
        fontWeight: 900
      },
      kioskOverlayCloseIcon: {
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'flex-end',
          width: '100%'
        },
        '& > * > *': {
          [theme.breakpoints.only('xs')]: {
            width: '30px'
          }
        }
      },
      popupOverlay: {
        position: 'fixed',
        top: '0',
        left: '38%',
        width: '30%',
        height: '85%',
        // backgroundColor: 'rgba(0, 0, 0, 0.5)', /* Semi-transparent background overlay */
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      },
      popup: {
        backgroundColor: 'ghostWhite',
        padding: '20px 10px',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
          width: 'auto'
        },
        [theme.breakpoints.only('xs')]: {
          height: '25%'
        },
        borderRadius: '40px',
        boxShadow: '9px 7px 6px rgba(0, 0, 0, 0.2)',
        border: '1px solid grey'
      },
      popupContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: '25px',
        fontWeight: 700,
        margin: '35px 0px'
      },
      message: {
        marginBottom: '50px'
      },
      closeButton: {
        padding: '10px 20px',
        borderRadius: '4px',
        backgroundColor: '#f46d2e',
        border: 'none',
        cursor: 'pointer'
      },
      body: {
        overflow: props && props.showDrawer ? 'hidden' : 'auto'
      }
    })
  );
